module.exports = __webpack_public_path__ + "img/2.bac36306.png";